import { CompanyPlacesDto } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import LoggedInUser from '../../../models/interfaces/LoggedInUser';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export const fetchLoggedInUser = createAction<FetchPayload>('FETCH_LOGGED_IN_USER');
export type FetchLoggedInUserActionType = Action<FetchPayload>;

export interface LoggedInUserFetchedPayload extends TimestampPayload {
  loggedInUser: LoggedInUser;
  companyPlaces: CompanyPlacesDto;
}
export const loggedInUserFetched = createAction<LoggedInUserFetchedPayload>('LOGGED_IN_USER_FETCHED');

type LoggedInUserFetchFailedPayload = TimestampPayload;
export const loggedInUserFetchFailed = createAction<LoggedInUserFetchFailedPayload>('LOGGED_IN_USER_FETCH_FAILED');
